// extracted by mini-css-extract-plugin
module.exports = {"Markdown":"Markdown_Markdown__2o5Na"};